import { createApp } from './app.js'

if (window.__INITIAL_STATE__) {
  const { app } = createApp(window.__INITIAL_STATE__)
  app.$mount('#app')
}

// TODO: fail if data isn't provided
